<section class="section pb-3 bg-white">
  <div class="container">
    <div class="row mb-4 mt-4">
      <div class="col offset-lg-1">
        <h1>Tlače a polepy</h1>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-10 col-lg-4 offset-lg-1 mb-md-5 mb-lg-0">
        <h2 class="mb-4 h5">
          Zabezpečíme pre vás kompletný tlačový servis
        </h2>
        <ul class="list-group ml-3 mb-4">
          <li class="m-0 p-0">
            <p class="text-muted">
              Digitálna, ofsetová a veľkoformátová tlač
            </p>
          </li>
          <li class="m-0 p-0">
            <p class="text-muted">
              PVC, mesh bannery a PVC samolepky
            </p>
          </li>
          <li class="m-0 p-0">
            <p class="text-muted">
              Katalógy, plagáty, vizitky, prezentácie
            </p>
          </li>
          <li class="m-0 p-0">
            <p class="text-muted">
              Plotrované/rezané samolepky
            </p>
          </li>
        </ul>
        <a href="#" class="btn btn-primary mb-5" [routerLink]="['/contacts']" fragment="obchod" (click)="closeNavBar()">
          Kontakt – obchod
        </a>
      </div>
      <div class="col-md-10 col-lg-5 offset-lg-1">
        <h2 class="mb-4 h5">
          Polepíme vaše autá a výklady podľa vašich predstáv
        </h2>
        <ul class="list-group ml-3">
          <li class="m-0 p-0">
            <p class="text-muted">
              Autá
            </p>
          </li>
          <li class="m-0 p-0">
            <p class="text-muted">
              Výklady a iné plochy
            </p>
          </li>
          <li class="m-0 p-0">
            <p class="text-muted">
              Realizácia outdoorovej reklamy
            </p>
          </li>
          <li class="m-0 p-0">
            <p class="text-muted">
              Výškové práce
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="section bg-light" id="foto">
  <div class="bg-triangle bg-triangle-dark bg-triangle-top bg-triangle-left"></div>
  <div class="bg-triangle bg-triangle-dark bg-triangle-bottom bg-triangle-right"></div>
  <div class="container mt-3">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6">
        <h3 class="text-center h2 mb-4">
          Fotogaléria
        </h3>
      </div>
    </div>
  </div>
  <gryf-galery [imageList]="images"></gryf-galery>
</section>
